/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The three core percentage calculations`)
};

const es_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los tres cálculos de porcentaje más comunes`)
};

const de_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die drei grundlegenden Prozentrechnungen`)
};

const nl_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De drie basisberekeningen voor percentages`)
};

const fr_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les trois calculs de pourcentage essentiels`)
};

const it_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tre calcoli percentuali fondamentali`)
};

const pt_br2_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os três cálculos essenciais de porcentagem`)
};

const pt_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os três cálculos essenciais de percentagem`)
};

const ja_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3つの基本的なパーセント計算`)
};

const zh_pct_nav_basic_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三种核心百分比计算`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_nav_basic_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_nav_basic_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_nav_basic_desc", locale)
	if (locale === "en") return en_pct_nav_basic_desc(inputs)
	if (locale === "es") return es_pct_nav_basic_desc(inputs)
	if (locale === "de") return de_pct_nav_basic_desc(inputs)
	if (locale === "nl") return nl_pct_nav_basic_desc(inputs)
	if (locale === "fr") return fr_pct_nav_basic_desc(inputs)
	if (locale === "it") return it_pct_nav_basic_desc(inputs)
	if (locale === "pt-BR") return pt_br2_pct_nav_basic_desc(inputs)
	if (locale === "pt") return pt_pct_nav_basic_desc(inputs)
	if (locale === "ja") return ja_pct_nav_basic_desc(inputs)
	return zh_pct_nav_basic_desc(inputs)
};